import axios from 'axios';
import { AppSettings } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
    UPLOAD_FILE,
    GET_FILE,
    CLEAR_FILE,
    DELETE_FILE,
    START_LOADING,
    STOP_LOADING
} from "./actionTypes";


export function clearFileAction() {
    return function (dispatch) {
        dispatch({
            type: CLEAR_FILE
        });
    }
}

export function deleteFileAction(transactionNo, fileNo, updateBy) {
    return function (dispatch) {
        try {
            dispatch({
                type : START_LOADING
              })

            let promise= axios({
                headers: { ...authHeader(), 'Pragma': 'no-cache' },
                method: "get",
                url: `${AppSettings.apiUrl}/api/Attachment/RemoveMrAttachment`,
                params: {
                    transactionNo : transactionNo,
                    fileNo : fileNo,
                    updateBy : updateBy,
                }
            })
            
            promise.then(response => {

                dispatch({
                    type: STOP_LOADING
                })

                dispatch({
                    type: DELETE_FILE
                });
            }
            );

            return promise

        } catch (error) {
            dispatch({
                type : STOP_LOADING
              })
        } finally {
        }
         
    }
}

export function uploadFileAction(data) {
    return function (dispatch) {
       
        const config = { headers: { 
            'Content-Type': 'multipart/form-data' },
            'Pragma': 'no-cache'
    };

        dispatch({
            type : START_LOADING
          })

        try {
            return axios.post(`${AppSettings.apiUrl}/api/Attachment/Upload`, data, config)
                        .then(response => {
                            dispatch({
                                type : STOP_LOADING
                              })

                            dispatch({
                                type: UPLOAD_FILE,
                                payload: response.data,
                            });
                        });
        } catch (error) {
            dispatch({
                type : STOP_LOADING
              })
            
        } finally {
        }

    }
}

export function getFileAction(transactionNo,uploadType) {
    return function (dispatch) {

        try {
            let promise= axios({
                headers: {...authHeader(),'Pragma': 'no-cache'},
                method: "get",
                url: `${AppSettings.apiUrl}/api/Attachment/GetMrAttachment`,
                params: {
                    transactionNo : transactionNo
                    
                }
            })

            promise.then(response => {
                dispatch({
                    type: GET_FILE,
                    uploadType:uploadType,
                    payload: response.data,
                });
            }
            );

            return promise

        } catch (error) {

        } finally {
        }
    }
}